<template>
  <div
    v-show="props.isOpen"
    class="dialog-overlay"
    @click.self="closeDialog"
    :style="overlayStyle"
  >
    <div
      class="storySlideContainer"
      @touchstart="onTouchStart"
      @touchmove="onTouchMove"
      @touchend="onTouchEnd"
      :style="storyStyle"
    >
      <div
        v-for="(user, indexUser) in props.users"
        :key="user.name"
        data-slide="slide"
        class="slide"
        :style="[userIndex === indexUser ? showSlide : hideSlide]"
      >
        <div
          class="slide-items"
          v-for="(story, indexStory) in user.stories"
          :key="indexStory"
          :class="{ active: activeIndex === indexStory }"
        >
          <div class="storyLoading">
            <span class="storyLoader"></span>
          </div>
          <img
            v-if="story.type === 'image'"
            v-lazy
            :data-src="story.src"
            :alt="story.alt"
            @load="handleStoryLoaded(indexUser, indexStory)"
          />
          <video
            v-if="story.type === 'video'"
            :ref="(el) => setVideoRef(el, indexUser, indexStory)"
            @loadedmetadata="setVideoDuration(indexUser, indexStory)"
            @loadeddata="handleStoryLoaded(indexUser, indexStory)"
            :muted="isMuted"
            playsinline
            webkit-playsinline
          >
            <source :src="story.src" type="video/mp4" />
          </video>
          <div class="slideTitle" v-show="isCurrentStoryLoaded">
            <div class="slideTitleContainer">
              <h2>{{ story.alt }}</h2>
              <div class="storyBtns">
                <div
                  v-show="props.userEdit && !removeLoading"
                  class="storyLinkBtn storyEditBtn"
                  @click="removeStoryHanlder"
                >
                  <i class="fas fa-trash"></i>
                </div>
                <div
                  v-show="props.userEdit && removeLoading"
                  class="storyLinkBtn storyEditBtn"
                >
                  <div class="removeLoader"></div>
                </div>
                <div
                  v-show="story.post_id"
                  class="storyLinkBtn"
                  @click="show_link(story.post_id)"
                >
                  <VsxIcon
                    iconName="Link1"
                    :size="28"
                    color="#fff"
                    type="linear"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="slideNavigationContainer">
          <div class="slideTimeLines">
            <span
              v-for="(item, index) in user.stories"
              :key="index"
              class="slideTimeLine"
              :class="{
                active: activeIndex === index,
                playing: isPlaying,
                played: activeIndex > index,
                loaded: isLoaded[`${props.userIndex}-${index}`],
              }"
              :style="{
                '--animation-duration':
                  item.type === 'video' &&
                  videoDurations[`${props.userIndex}-${index}`]
                    ? `${videoDurations[`${props.userIndex}-${index}`] / 1000}s`
                    : '5s',
              }"
            ></span>
          </div>
          <div class="userInfoContainer">
            <div class="userInfoContainerColumn">
              <div class="closeStoryButton">
                <div class="close-button" @click="closeDialog">
                  <VsxIcon
                    class="closeIcon"
                    iconName="CloseCircle"
                    :size="30"
                    color="#fff"
                    type="bold"
                  />
                </div>
              </div>
              <div class="playPauseButton">
                <div class="play-pause-button" @click="togglePlayPause">
                  <VsxIcon
                    v-show="!isPlaying"
                    class="playPauseIcon"
                    iconName="Play"
                    :size="30"
                    color="#fff"
                    type="bold"
                  />
                  <VsxIcon
                    v-show="isPlaying"
                    iconName="Pause"
                    :size="30"
                    color="#fff"
                    type="bold"
                  />
                </div>
              </div>
              <div class="muteButton" v-if="currentStoryType === 'video'">
                <div class="mute-button" @click="toggleMute">
                  <VsxIcon
                    v-show="isMuted"
                    iconName="VolumeCross"
                    :size="30"
                    color="#fff"
                    type="bold"
                  />
                  <VsxIcon
                    v-show="!isMuted"
                    iconName="VolumeHigh"
                    :size="30"
                    color="#fff"
                    type="bold"
                  />
                </div>
              </div>
            </div>
            <div class="userInfoContainerColumn">
              <div
                class="userName"
                @click="goUserProfile(`/profile-amlak?bid=${user.branch_id}`)"
              >
                <span>{{ user.name }}</span>
              </div>
              <div
                class="userProfileWrapper"
                @click="goUserProfile(`/profile-amlak?bid=${user.branch_id}`)"
              >
                <img :src="user.profile" alt="" />
              </div>
              <!-- <router-link
                :to="`/profile-amlak?bid=${user.branch_id}`"
                class="userName"
              >
                <span>{{ user.name }}</span>
              </router-link>
              <router-link
                :to="`/profile-amlak?bid=${user.branch_id}`"
                class="userProfileWrapper"
              >
                <img :src="user.profile" alt="" />
              </router-link> -->
            </div>
          </div>
          <div class="slideNavigationButtonsMobile">
            <div class="slide-prev nav_button" @click="prevSlide"></div>
            <div class="slide-next nav_button" @click="nextSlide"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="slideNavigationButtonsDesktop">
      <div class="slide-prev nav_button" @click="prevSlide">
        <VsxIcon
          iconName="ArrowRight2"
          :size="20"
          color="#6c6c6c"
          type="linear"
        />
      </div>
      <div class="slide-next nav_button" @click="nextSlide">
        <VsxIcon
          iconName="ArrowLeft2"
          :size="20"
          color="#6c6c6c"
          type="linear"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  watch,
  onMounted,
  defineProps,
  defineEmits,
  nextTick,
  reactive,
  computed,
  onBeforeUnmount,
} from "vue";
import { VsxIcon } from "vue-iconsax";
import { useRouter } from "vue-router";
import axios from "axios";
import { useStore } from "vuex";

const router = useRouter();

const store = useStore();

const props = defineProps({
  users: {
    type: Array,
    required: true,
  },
  userIndex: {
    type: Number,
    required: true,
  },
  isOpen: {
    type: Boolean,
    required: true,
  },
  isClose: {
    type: Function,
    required: true,
  },
  isBackAction: {
    type: Boolean,
    required: true,
  },
  userEdit: {
    type: Boolean,
    required: true,
  },
  nextUser: {
    type: Function,
    required: false,
  },
  prevUser: {
    type: Function,
    required: false,
  },
  removeStory: {
    type: Function,
    required: false,
  },
  loadStory: {
    type: Function,
    required: false,
  },
  // updateStoryStatus: {
  //   type: Function,
  // },
  // initialStoryIndex: {
  //   type: Number,
  // },
});

const emit = defineEmits(["close", "update-back-action"]);

// const activeIndex = ref(props.initialStoryIndex(props.userIndex));
const activeIndex = ref(0);
const isPlaying = ref(true);
const videoRefs = ref({});
const remainingTime = ref(5000);
const videoDurations = ref({});
const isMuted = ref(true);
const isLoaded = ref({});

const isDragging = ref(false);
const startY = ref(0);
const currentY = ref(0);
const overlayStyle = ref({});
const storyStyle = ref({});
const loadTimeouts = ref({});

const isCurrentStoryLoaded = computed(() => {
  const key = `${props.userIndex}-${activeIndex.value}`;
  return isLoaded.value[key];
});

// const handleStoryLoaded = (indexUser, indexStory) => {
//   const key = `${indexUser}-${indexStory}`;
//   isLoaded.value[key] = true;
//   console.log(`Story ${key} loaded`);

//   // اگر اسلاید فعلی لود شد، پخش استوری را شروع کن
//   if (indexUser === props.userIndex && indexStory === activeIndex.value) {
//     nextTick(() => {
//       resetAutoSlide();
//     });
//   }
// };

const handleStoryLoaded = (indexUser, indexStory) => {
  const key = `${indexUser}-${indexStory}`;
  isLoaded.value[key] = true;
  console.log(`Story ${key} loaded`);

  // اگر تایم‌اوت لودینگ وجود داشت، پاکش کن
  if (loadTimeouts.value[key]) {
    clearTimeout(loadTimeouts.value[key]);
    delete loadTimeouts.value[key];
  }

  // اگر اسلاید فعلی لود شد، پخش استوری را شروع کن
  if (indexUser === props.userIndex && indexStory === activeIndex.value) {
    nextTick(() => {
      resetAutoSlide();
    });
  }
};

const onTouchStart = (event) => {
  if (!props.isOpen) return;
  isDragging.value = true;
  startY.value = event.touches[0].clientY;
  if (event.target === event.currentTarget) {
    event.preventDefault();
  }
};

const onTouchMove = (event) => {
  if (!isDragging.value || !props.isOpen) return;

  currentY.value = event.touches[0].clientY;
  const deltaY = currentY.value - startY.value;

  if (deltaY > 0) {
    overlayStyle.value = {
      opacity: 1 - deltaY / 300,
    };
    storyStyle.value = {
      transform: `translateY(${deltaY}px)`,
      transition: "none",
    };
    if (event.target === event.currentTarget) {
      event.preventDefault();
    }
  }
};

const onTouchEnd = () => {
  const deltaY = currentY.value - startY.value;

  if (deltaY > 200) {
    closeDialog();
  } else {
    overlayStyle.value = {
      opacity: 1,
      transition: "opacity 0.3s ease",
    };
    storyStyle.value = {
      transform: "translateY(0)",
      transition: "transform 0.3s ease",
    };
  }

  isDragging.value = false;
  startY.value = 0;
  currentY.value = 0;
};

const currentStoryType = computed(() => {
  if (
    props.userIndex >= 0 &&
    props.userIndex < props.users.length &&
    activeIndex.value >= 0 &&
    activeIndex.value < props.users[props.userIndex].stories.length
  ) {
    return props.users[props.userIndex].stories[activeIndex.value].type;
  }
  return null;
});

const setVideoRef = (el, indexUser, indexStory) => {
  if (el) {
    const key = `${indexUser}-${indexStory}`;
    videoRefs.value[key] = el;
    el.muted = isMuted.value;
  }
};

const setVideoDuration = (indexUser, indexStory) => {
  const key = `${indexUser}-${indexStory}`;
  if (videoRefs.value[key]) {
    videoDurations.value[key] = videoRefs.value[key].duration * 1000;
  }
};

const playCurrentVideo = async (resetTime = true) => {
  const key = `${props.userIndex}-${activeIndex.value}`;
  if (!isLoaded.value[key]) {
    console.log(`Story ${key} is not loaded yet`);
    return;
  }

  if (
    props.userIndex >= 0 &&
    props.userIndex < props.users.length &&
    activeIndex.value >= 0 &&
    activeIndex.value < props.users[props.userIndex].stories.length
  ) {
    const currentStory =
      props.users[props.userIndex].stories[activeIndex.value];
    if (currentStory.type === "video" && videoRefs.value[key]) {
      const video = await videoRefs.value[key];
      if (resetTime) {
        video.currentTime = 0;
      }
      video.muted = isMuted.value;
      await new Promise((resolve) => {
        if (video.paused) {
          video.play().then(resolve).catch(console.error);
        } else {
          video.oncanplay = () => resolve();
        }
      });
    }
  }
};

const pauseCurrentVideo = () => {
  if (
    props.userIndex >= 0 &&
    props.userIndex < props.users.length &&
    activeIndex.value >= 0 &&
    activeIndex.value < props.users[props.userIndex].stories.length
  ) {
    const currentStory =
      props.users[props.userIndex].stories[activeIndex.value];
    const key = `${props.userIndex}-${activeIndex.value}`;
    if (currentStory.type === "video" && videoRefs.value[key]) {
      videoRefs.value[key].pause();
    }
  }
};

const stopAllVideos = () => {
  Object.values(videoRefs.value).forEach((video) => {
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  });
  videoRefs.value = {};
};

const showSlide = reactive({
  display: "block",
});

const hideSlide = reactive({
  display: "none",
});

let timeout;
let startTime;

const nextSlide = () => {
  pauseCurrentVideo();

  const nextIndex = activeIndex.value + 1;
  // const key = `${props.userIndex}-${nextIndex}`;

  if (nextIndex < props.users[props.userIndex].stories.length) {
    activeIndex.value = nextIndex;
    isPlaying.value = true;
    resetAutoSlide();
    // props.updateStoryStatus(props.userIndex, activeIndex.value);
  } else if (props.userIndex < props.users.length - 1) {
    stopAllVideos();
    if (props.nextUser) {
      props.nextUser();
    } else {
      closeDialog();
    }
    nextTick(() => {
      // activeIndex.value = props.initialStoryIndex(props.userIndex);
      activeIndex.value = 0;
      isPlaying.value = true;
      resetAutoSlide();
    });
  } else {
    closeDialog();
  }

  playCurrentVideo(true);
  // props.updateStoryStatus(props.userIndex, activeIndex.value);
};

const prevSlide = () => {
  pauseCurrentVideo();

  const prevIndex = activeIndex.value - 1;
  // const key = `${props.userIndex}-${prevIndex}`;

  if (prevIndex >= 0) {
    activeIndex.value = prevIndex;
    isPlaying.value = true;
    resetAutoSlide();
    // props.updateStoryStatus(props.userIndex, activeIndex.value);
  } else if (props.userIndex > 0) {
    stopAllVideos();
    if (props.prevUser) {
      props.prevUser();
    } else {
      closeDialog();
    }
    nextTick(() => {
      // activeIndex.value = props.initialStoryIndex(props.userIndex);
      activeIndex.value = 0;
      isPlaying.value = true;
      resetAutoSlide();
    });
  } else {
    closeDialog();
  }

  playCurrentVideo(true);
};

const resetAutoSlide = () => {
  if (isPlaying.value) {
    if (timeout !== null) {
      clearTimeout(timeout);
    }

    const key = `${props.userIndex}-${activeIndex.value}`;
    // if (!isLoaded.value[key]) {
    //   console.log(`Story ${key} is not loaded yet`);
    //   return;
    // }

    if (!isLoaded.value[key]) {
      console.log(`Story ${key} is not loaded yet, setting timeout...`);

      // تایم‌اوت قبلی را پاک کن (اگر وجود داشت)
      if (loadTimeouts.value[key]) {
        clearTimeout(loadTimeouts.value[key]);
      }

      // تایم‌اوت جدید برای 10 ثانیه تنظیم کن
      loadTimeouts.value[key] = setTimeout(() => {
        console.log(
          `Story ${key} failed to load in 10 seconds, moving to next...`
        );
        nextSlide();
      }, 7500);

      return;
    }

    if (
      props.userIndex >= 0 &&
      props.userIndex < props.users.length &&
      activeIndex.value >= 0 &&
      activeIndex.value < props.users[props.userIndex].stories.length
    ) {
      const currentStory =
        props.users[props.userIndex].stories[activeIndex.value];
      if (currentStory.type === "video" && videoRefs.value[key]) {
        videoRefs.value[key].oncanplay = () => {
          remainingTime.value = videoDurations.value[key];
          startTime = Date.now();
          timeout = setTimeout(nextSlide, remainingTime.value);
          playCurrentVideo(true);
        };
      } else {
        remainingTime.value = 5000;
        startTime = Date.now();
        timeout = setTimeout(nextSlide, remainingTime.value);
        playCurrentVideo(true);
      }
    }
  }
};

const pauseSlide = () => {
  isPlaying.value = false;
  if (timeout !== null) {
    clearTimeout(timeout);
    const elapsedTime = Date.now() - startTime;
    remainingTime.value -= elapsedTime;
  }

  pauseCurrentVideo();
};

const resumeSlide = () => {
  isPlaying.value = true;
  if (timeout !== null) {
    clearTimeout(timeout);
  }
  startTime = Date.now();
  timeout = setTimeout(nextSlide, remainingTime.value);

  playCurrentVideo(false);
};

const togglePlayPause = () => {
  if (isPlaying.value) {
    pauseSlide();
  } else {
    resumeSlide();
  }
};

// const show_link = (post_id) => {
//   // alert();
//   window.location.href + "/detail?id=" + post_id;
// };

const show_link = (post_id) => {
  // closeDialog();

  Object.values(loadTimeouts.value).forEach((timeoutId) => {
    clearTimeout(timeoutId);
  });
  loadTimeouts.value = {};
  clearTimeout(timeout);
  stopAllVideos();
  resetSlides();
  videoRefs.value = {};
  document.body.style.overflow = "auto";

  router.replace(`/details/${post_id}`);
};

const toggleMute = () => {
  isMuted.value = !isMuted.value;
  if (
    props.userIndex >= 0 &&
    props.userIndex < props.users.length &&
    activeIndex.value >= 0 &&
    activeIndex.value < props.users[props.userIndex].stories.length
  ) {
    const currentStory =
      props.users[props.userIndex].stories[activeIndex.value];
    const key = `${props.userIndex}-${activeIndex.value}`;
    if (currentStory.type === "video" && videoRefs.value[key]) {
      videoRefs.value[key].muted = isMuted.value;
    }
  }
};

onMounted(() => {
  window.addEventListener("popstate", handleBackButton);
  console.log(props.users);
  nextTick(() => {
    resetAutoSlide();
  });
  console.log(props.users);
});
onBeforeUnmount(() => {
  window.addEventListener("popstate", handleBackButton);
});
const resetSlides = () => {
  activeIndex.value = 0;
};

watch(
  () => props.isOpen,
  (newValue) => {
    if (newValue) {
      resetSlides();
      resetAutoSlide();
    }
  }
);

const removeLoading = ref(false);

const closeDialog = () => {
  // props.updateStoryStatus(props.userIndex, activeIndex.value);
  Object.values(loadTimeouts.value).forEach((timeoutId) => {
    clearTimeout(timeoutId);
  });
  loadTimeouts.value = {};
  emit("close");
  clearTimeout(timeout);
  stopAllVideos();
  resetSlides();
  videoRefs.value = {};
  removeLoading.value = false;
  document.body.style.overflow = "auto";
};


const removeStoryHanlder = async () => {
  // props.removeStory(props.userIndex, activeIndex.value);
  try {
    removeLoading.value = true;
    await axios.post(
      store.getters.baseUrl + "/del-story",
      { id: props.users[0].stories[activeIndex.value].id },
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + store.getters.appToken,
        },
      }
    );
    closeDialog();
    props.loadStory();
  } catch (error) {
    console.error(error);
  }
  // axios.post(
  //   self.$store.getters.baseUrl + "/del-story",
  //   { id: props.users[0].stories[activeIndex].id },
  //   {
  //     headers: {
  //       "Content-Type": "multipart/form-data", // Set the content type for file upload
  //       Authorization: "Bearer " + self.$store.getters.appToken,
  //     },
  //   }
  // );
};

const handleBackButton = () => {
  if (props.isOpen) {
    emit("update-back-action", true);
    closeDialog();
    document.body.style.overflowY = "auto";
    emit("update-back-action", false);
  }
  document.body.style.overflow = "auto";
};

const goUserProfile = (to) => {
  history.replaceState(null, "", to);
  router.replace(to);
};
</script>

<style lang="scss" scoped>

.removeLoader {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  border-top: 3px solid #fff;
  border-right: 3px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.slide-items {
  position: relative;

  .slideTitle {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    margin: 0 auto;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;

    &::before {
      content: "";
      display: block;
      height: 0;
      padding-top: calc(1 / 3 * 100%);
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1));
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
      z-index: 1;
    }

    .slideTitleContainer {
      position: relative;
      width: 90%;
      margin: 0 auto;
      padding: 16px 0;
      z-index: 2;
      display: flex;
      flex-direction: row-reverse;
      align-items: flex-end;
      justify-content: space-between;

      h2 {
        width: calc(100% - 46px);
        color: #fff;
        font-size: 1rem;
        margin-bottom: 8px;
      }

      .storyBtns {
        display: flex;
        flex-direction: column-reverse;
        gap: 0;
        align-items: center;
      }

      .storyLinkBtn {
        cursor: pointer;

        &.storyEditBtn {
          width: 42px;
          height: 42px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          color: #fff;
          background: #f00;
          border-radius: 6px;
          margin-top: 12px;
        }
      }
    }
  }
}
</style>
